import React from 'react';

const baseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'var(--icon-primary, #5b21b6)',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
};

export function IconBook({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path
        d="M4 6h6a2 2 0 0 1 2 2v12H6a2 2 0 0 0-2 2V8a2 2 0 0 1 2-2z"
        fill="var(--icon-accent, #f7c978)"
        stroke="none"
      />
      <path
        d="M20 6h-6a2 2 0 0 0-2 2v12h6a2 2 0 0 1 2 2V8a2 2 0 0 0-2-2z"
        fill="var(--icon-accent-2, #fde7b4)"
        stroke="none"
      />
      <path d="M4 6h6a2 2 0 0 1 2 2v12H6a2 2 0 0 0-2 2V8a2 2 0 0 1 2-2z" />
      <path d="M20 6h-6a2 2 0 0 0-2 2v12h6a2 2 0 0 1 2 2V8a2 2 0 0 0-2-2z" />
      <path d="M12 8v12" />
    </svg>
  );
}

export function IconCalculator({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <rect
        x="4"
        y="3"
        width="16"
        height="18"
        rx="2"
        fill="var(--icon-accent, #a7f3d0)"
        stroke="none"
      />
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <line x1="7" y1="8" x2="17" y2="8" />
      <circle cx="8" cy="12" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="16" cy="12" r="1" />
      <circle cx="8" cy="16" r="1" />
      <circle cx="12" cy="16" r="1" />
      <circle cx="16" cy="16" r="1" />
    </svg>
  );
}

export function IconGlobe({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <circle cx="12" cy="12" r="9" fill="var(--icon-accent, #bae6fd)" stroke="none" />
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3a14 14 0 0 1 0 18" />
      <path d="M12 3a14 14 0 0 0 0 18" />
    </svg>
  );
}

export function IconAtom({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <circle cx="12" cy="12" r="3" fill="var(--icon-accent, #fda4af)" stroke="none" />
      <circle cx="12" cy="12" r="1.5" />
      <ellipse cx="12" cy="12" rx="8" ry="3.5" />
      <ellipse cx="12" cy="12" rx="8" ry="3.5" transform="rotate(60 12 12)" />
      <ellipse cx="12" cy="12" rx="8" ry="3.5" transform="rotate(-60 12 12)" />
    </svg>
  );
}

export function IconTarget({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <circle cx="12" cy="12" r="8.5" fill="var(--icon-accent, #fde68a)" stroke="none" />
      <circle cx="12" cy="12" r="4" fill="var(--icon-accent-2, #fca5a5)" stroke="none" />
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="4" />
      <path d="M12 3v3" />
      <path d="M12 18v3" />
      <path d="M3 12h3" />
      <path d="M18 12h3" />
    </svg>
  );
}

export function IconPalette({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <circle cx="12" cy="12" r="9" fill="var(--icon-accent, #fbcfe8)" stroke="none" />
      <circle cx="9" cy="9" r="1.2" fill="var(--icon-accent-2, #fcd34d)" stroke="none" />
      <circle cx="14" cy="8" r="1.2" fill="var(--icon-accent-2, #93c5fd)" stroke="none" />
      <circle cx="15" cy="13" r="1.2" fill="var(--icon-accent-2, #86efac)" stroke="none" />
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 14.5c1.5 1 3.5 1 5 0" />
    </svg>
  );
}

export function IconHeart({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path
        d="M12 20s-6-3.5-8-7.5A4.5 4.5 0 0 1 11.5 6L12 6.5l.5-.5A4.5 4.5 0 0 1 20 12.5C18 16.5 12 20 12 20z"
        fill="var(--icon-accent, #fda4af)"
        stroke="none"
      />
      <path d="M12 20s-6-3.5-8-7.5A4.5 4.5 0 0 1 11.5 6L12 6.5l.5-.5A4.5 4.5 0 0 1 20 12.5C18 16.5 12 20 12 20z" />
    </svg>
  );
}

export function IconLeaf({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path
        d="M5 19c7-1 11-6 14-14-8 1-13 5-14 14z"
        fill="var(--icon-accent, #86efac)"
        stroke="none"
      />
      <path d="M5 19c7-1 11-6 14-14-8 1-13 5-14 14z" />
      <path d="M5 19c4-4 7-7 11-11" />
    </svg>
  );
}

export function IconSparkles({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path
        d="M12 4l1.5 3.5L17 9l-3.5 1.5L12 14l-1.5-3.5L7 9l3.5-1.5L12 4z"
        fill="var(--icon-accent, #fcd34d)"
        stroke="none"
      />
      <path d="M12 4l1.5 3.5L17 9l-3.5 1.5L12 14l-1.5-3.5L7 9l3.5-1.5L12 4z" />
      <path
        d="M18 5l.7 1.6L20 7l-1.3.5L18 9l-.7-1.5L16 7l1.3-.4L18 5z"
        fill="var(--icon-accent-2, #fda4af)"
        stroke="none"
      />
      <path d="M18 5l.7 1.6L20 7l-1.3.5L18 9l-.7-1.5L16 7l1.3-.4L18 5z" />
    </svg>
  );
}

export function IconCap({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M3 9l9-4 9 4-9 4-9-4z" fill="var(--icon-accent, #c4b5fd)" stroke="none" />
      <path d="M3 9l9-4 9 4-9 4-9-4z" />
      <path d="M7 11v4a5 5 0 0 0 10 0v-4" />
      <path d="M21 10v5" />
    </svg>
  );
}

export function IconStar({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path
        d="M12 3l2.5 5 5.5.8-4 3.9.9 5.4-4.9-2.6-4.9 2.6.9-5.4-4-3.9 5.5-.8L12 3z"
        fill="var(--icon-accent, #fcd34d)"
        stroke="none"
      />
      <path d="M12 3l2.5 5 5.5.8-4 3.9.9 5.4-4.9-2.6-4.9 2.6.9-5.4-4-3.9 5.5-.8L12 3z" />
    </svg>
  );
}

export function IconChart({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M4 19h16" />
      <rect x="6" y="10" width="3" height="7" rx="1" fill="var(--icon-accent, #93c5fd)" stroke="none" />
      <rect x="11" y="7" width="3" height="10" rx="1" fill="var(--icon-accent-2, #fde68a)" stroke="none" />
      <rect x="16" y="5" width="3" height="12" rx="1" fill="var(--icon-accent, #a7f3d0)" stroke="none" />
      <rect x="6" y="10" width="3" height="7" rx="1" />
      <rect x="11" y="7" width="3" height="10" rx="1" />
      <rect x="16" y="5" width="3" height="12" rx="1" />
    </svg>
  );
}

export function IconBriefcase({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <rect x="4" y="7" width="16" height="12" rx="2" fill="var(--icon-accent, #fbcfe8)" stroke="none" />
      <rect x="4" y="7" width="16" height="12" rx="2" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      <path d="M4 12h16" />
    </svg>
  );
}

export function IconMonitor({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <rect x="3" y="4" width="18" height="12" rx="2" fill="var(--icon-accent, #bae6fd)" stroke="none" />
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8" />
      <path d="M12 16v4" />
    </svg>
  );
}

export function IconActivity({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M3 12h4l2-4 4 8 2-4h4" />
    </svg>
  );
}

export function IconLanguage({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path
        d="M4 6h10a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4H8l-4 3v-3"
        fill="var(--icon-accent, #c7d2fe)"
        stroke="none"
      />
      <path d="M4 6h10a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4H8l-4 3v-3" />
      <path d="M7 10h6" />
      <path d="M7 14h4" />
    </svg>
  );
}

export function IconCheck({ className }) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M5 12l4 4 10-10" />
    </svg>
  );
}

export function IconDot({ className }) {
  return (
    <svg className={className} viewBox="0 0 8 8" fill="currentColor" aria-hidden="true" focusable="false">
      <circle cx="4" cy="4" r="3" />
    </svg>
  );
}
